/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, Grid, styled, Typography, Tab, Modal } from "@mui/material";
import React, { useState } from "react";
import { fonts, themes } from "../../../common/themes/themes";
import { useAppSelector } from "../../../infra/hooks";
import "./DigitalSignature.css";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import SearchComponent from "../../../common/components/SearchComponent";
import { DataGrid } from "@mui/x-data-grid";
import { DateField } from "../../../components";
import { baseDateFormatting } from "../../../common/helper";
import _ from "lodash";
import DigiSignatureTools from "../../../common/digisignature/DigiSignatureTools";
import ViewDigitalDocsController from "../../../domain/myProfile/digitalSignature/ViewDigitalSignDocs/ViewDigitalDocsController";
import ImageViewer from "../../../common/components/ImageViewer/ImageViewer";

const CustomTabList = styled(TabList)(() => ({
  "& .Mui-selected": {
    textTransform: "capitalize",

    color: "#7C0E6F",
  },
  "& .css-1h9z7r5-MuiButtonBase-root-MuiTab-root.Mui-selected": {
    color: "#7C0E6F",
  },
  "& .MuiButtonBase-root": {
    textTransform: "capitalize",
    fontWeight: "bold",
  },
  "& .css-1aquho2-MuiTabs-indicator": {
    backgroundColor: "#7C0E6F",
  },
}));

const styles = {
  viewbox: {
    border: '1px solid #E6E8EF',
    color: '#7C0E6F',
    width: '1.8125em',
    height: '1.8125em',
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    borderRadius: '0.375em',
    cursor: 'pointer',
  },
  historyBox: {
    border: '1px solid #E6E8EF',
    color: '#8181a5',
    width: '1.8125em',
    height: '1.8125em',
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    borderRadius: '0.375em',
    cursor: 'pointer',
  },
  sign: {
    border: '1px solid #E6E8EF',
    color: '#008000',
    width: '1.8125em',
    height: '1.8125em',
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    borderRadius: '0.375em',
    cursor: 'pointer',
  },
};
interface propDigitalSignature {
  trans?: any;
  i18n?: any;
  data?: any;
  count?: any;
  setSearch?: (data: any) => void | undefined;
  setPage?: (data: any) => void | undefined;
  setLimit?: (data: any) => void | undefined;
  submit?: (payload: any, id: any) => string | undefined;
}

const DigitalSignaturePresenter = ({ trans, i18n, data, setSearch, setPage, setLimit, submit, count }: propDigitalSignature) => {
  const isHRView = useAppSelector((state) => state.isHRViewSlice.HRView);

  const [pageSize, setPageSize] = useState(10);
  const [pageL, setPageL] = useState(1);
  const [openModel, closeModal] = useState(false);
  const [openModel2, closeModal2] = useState(false);
  const [openModel3, closeModal3] = useState(false);
  const [viewData, setViewData] = useState<any>();
  const [attachment, setAttachment] = useState(null);

  const handleGetTextFilter = (search: any) => {
    setSearch?.(search)
  };
  const handleGetPageFilter = (page: any) => {
    setPage?.(page)
    setPageL(page)
  };
  const handleGetLimitFilter = (limit: any) => {
    setLimit?.(limit)
    setPageSize(limit)
  };

  const tableColumns: any = [
    {
      field: 'documentType',
      headerName: trans('Document Type'),
      width: 50,
      headerClassName: 'header',
      height: 90,
      flex: 1,
    },
    {
      field: 'createdBy',
      headerName: trans('Created By'),
      width: 50,
      headerClassName: 'header',
      height: 90,
      flex: 1,
    },
    {
      field: 'signedBy',
      headerName: trans('Signed By'),
      width: 50,
      headerClassName: 'header',
      height: 90,
      flex: 1,
    },
    {
      field: 'createdAt',
      headerName: trans('Created At'),
      headerClassName: 'header',
      height: 70,
      flex: 1,
      renderCell: (params: any) => {
        return (
          <DateField
            value={params.row.createdAt}
            format={baseDateFormatting}
          // offset={params?.row?.timezone?.offset}
          />
        );
      },
    },
    {
      field: 'updatedAt',
      headerName: trans('Updated At'),
      headerClassName: 'header',
      height: 70,
      flex: 1,
      renderCell: (params: any) => {
        return (
          <DateField
            value={params.row.updatedAt}
            format={baseDateFormatting}
          // offset={params?.row?.timezone?.offset}
          />
        );
      },
    },
    {
      field: 'status',
      headerName: trans('Status'),
      headerClassName: 'header',
      height: 70,
      flex: 1,
      renderCell: (params: any) => {
        return params?.row?.status?.name == 'Requested' ? (
          <Typography
            style={{
              color: '#ffffff',
              fontFamily: fonts.fontFamily,
              fontSize: fonts.subtitle,
              textTransform: 'capitalize',
              fontWeight: 'bold',
              backgroundColor: '#06b6d4',
              padding: '2px',
              borderRadius: '6px'
            }}
          >
            {trans(params?.row?.status?.name)}
          </Typography>
        ) : params?.row?.status?.name == 'Signed' ? (
          <Typography
            style={{
              color: '#ffffff',
              backgroundColor: '#4b5563',
              fontFamily: fonts.fontFamily,
              fontSize: fonts.subtitle,
              textTransform: 'capitalize',
              fontWeight: 'bold',
              padding: '2px',
              borderRadius: '6px'
            }}
          >
            {trans(params?.row?.status?.name)}
          </Typography>
        ) : params?.row?.status?.name == 'Canceled' ? (
          <Typography
            style={{
              color: '#ffffff',
              backgroundColor: '#ef4444',
              fontFamily: fonts.fontFamily,
              fontSize: fonts.subtitle,
              textTransform: 'capitalize',
              fontWeight: 'bold',
              padding: '2px',
              borderRadius: '6px'
            }}
          >
            {trans(params?.row?.status?.name)}
          </Typography>
        ) : params?.row?.status?.name == 'Rejected' ? (
          <Typography
            style={{
              color: themes.red,
              backgroundColor: '#FDEDEF',
              fontFamily: fonts.fontFamily,
              fontSize: fonts.subtitle,
              textTransform: 'capitalize',
              fontWeight: 'bold',
              padding: '2px',
              borderRadius: '6px'
            }}
          >
            {trans(params?.row?.status?.name)}
          </Typography>
        ) : params?.row?.status?.name == 'Drafted' ? (
          <Typography
            style={{
              color: '#000000',
              backgroundColor: '#f59e0b',
              fontFamily: fonts.fontFamily,
              fontSize: fonts.subtitle,
              textTransform: 'capitalize',
              fontWeight: 'bold',
              padding: '2px',
              borderRadius: '6px'
            }}
          >
            {trans(params?.row?.status?.name)}
          </Typography>
        ) : (
          ''
        );
      },
    },
    {
      field: 'action',
      headerName: trans('Action'),
      headerClassName: 'header',
      height: 70,
      flex: 1,
      renderCell: (params: any) => {
        return (
          <div style={{ display: 'flex', flexDirection: 'row', columnGap: 8 }}>
            <Grid item xs={3}>
              <Box style={styles?.viewbox} onClick={() => handleView(params?.row?.action)}>
                <i className="las la-eye" style={{ fontSize: '1.125rem' }}></i>
              </Box>
            </Grid>
            <Grid item xs={3}>
              <Box style={styles?.historyBox} onClick={() => handleHistory(params?.row?.action)}>
                <i className="las la-history" style={{ fontSize: '1.125rem' }}></i>
              </Box>
            </Grid>
            {[1].includes(params?.row?.status?.id) && (
              <Grid item xs={3}>
              <Box style={styles?.sign} onClick={() => handleSign(params?.row?.action)}>
                <i className="las la-signature" style={{ fontSize: '1.125rem' }}></i>
              </Box>
            
            </Grid>)}
          </div>
        )
      },
    }
  ];

  const status = [
    { id: 1, name: 'Requested' },
    { id: 2, name: 'Signed' },
    { id: 3, name: 'Canceled' },
    { id: 4, name: 'Rejected' },
    { id: 5, name: 'Drafted' },
  ];

  const digiSignDocsData = _.map(data, (data) => {
    return {
      id: data?.id,
      staffId: data?.staff_id,
      employeeName: data?.staff_name,
      documentType: data?.document_type_name,
      createdBy: data?.created_by_name,
      signedBy: data?.signed_by_name ?? "--:--",
      status: status?.find((stat) => stat?.id === data?.status),
      createdAt: data?.created_at,
      updatedAt: data?.updated_at,
      action: data
    }
  });

  const handleSign = (data: any) => {
    setViewData?.(data)
    closeModal(true)
  }

  const handleView = (data: any) => {
    setAttachment(data?.attachment)
    closeModal3(true)
  }

  const handleSubmit = (payload: any) => {
    submit?.(payload, viewData?.id)
    closeModal(false)
  }

  const handleHistory = (data: any) => {
    setViewData(data)
    closeModal2(true)
  }

  return (
    <Grid
      container
      style={{
        display: "flex",
        flexWrap: "nowrap",
        marginTop: isHRView ? "" : "4em",
        width: "100vw",
        // paddingRight: "8em",
      }}
    >
      <Grid
        item
        xs={11}
        sm={11}
        md={11}
        lg={11}
        sx={{
          backgroundColor: "#F5F5FA",
          width: "100%",
          padding: "1.75em",
          marginLeft:
            isHRView && i18n.language == "en"
              ? "11em"
              : !isHRView && i18n.language == "en"
                ? "14em"
                : "",
          marginRight: i18n.language == "ar" ? "15em" : "",
        }}
      >
        <Grid
          container
          style={{
            paddingLeft: isHRView ? "2em" : "",
          }}
        >
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            sx={{
              width: "100%",
              height: "80px",
            }}
          >
            <Grid
              container
              style={{
                width: "auto",
                background: "#FFFFFF 0% 0% no-repeat padding-box",
                borderRadius: "10px",
                opacity: "1",
                display: "flex",
                flexDirection: "row",
                paddingTop: "1em",
                paddingBottom: "1em",
                paddingLeft: "1em",
                paddingRight: "1em",
              }}
            >
              <Grid item xs={9}>
                <Typography
                  style={{
                    fontFamily: fonts.fontFamily,
                    fontSize: fonts.header,
                    color: themes.blackDefault,
                    fontWeight: "bold",
                  }}
                >
                  {trans("Digital Signature Docs")}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            sx={{
              width: "100%",
              maxHeight: "80px",
            }}
          >
            <Grid
              container
              style={{
                width: "auto",
                background: "#FFFFFF 0% 0% no-repeat padding-box",
                borderRadius: "10px",
                opacity: "1",
                display: "flex",
                flexDirection: "row",
                paddingTop: "1em",
                paddingBottom: "1em",
                paddingLeft: "1em",
                paddingRight: "1em",
              }}
            >
              <Grid item xs={12}>
                <Box
                  sx={{
                    "& .header": {
                      backgroundColor: "#F5F5F5",
                    },
                  }}
                >
                  <Grid container style={{ marginTop: "1em" }}>
                    <Grid item xs={12}>
                      <SearchComponent onChange={handleGetTextFilter} />
                      <Box
                        sx={{
                          maxWidth: '78vw',         
                          maxHeight: '50vh',   
                          overflow: 'auto',      
                        }}
                      >
                        <DataGrid
                          sx={{
                            fontSize: fonts.subtitle,
                            color: '#081735',
                            fontFamily: fonts.fontFamily,
                            marginTop: '1.5em',
                          }}
                          autoHeight={true}
                          autoPageSize={false}
                          disableColumnMenu
                          pageSize={pageSize}
                          onPageSizeChange={(newPageSize) => handleGetLimitFilter(newPageSize)}
                          rowsPerPageOptions={[10, 25, 50, 100]}
                          disableSelectionOnClick
                          rows={digiSignDocsData}
                          columns={tableColumns}
                          rowCount={count}
                          paginationMode="server"
                          page={pageL} // current page number (0-based index)
                          onPageChange={(newPage) => handleGetPageFilter(newPage)}
                        />
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Modal open={openModel} onClose={() => closeModal(false)} >
        <div
          className="custom-modal2"
        >
          <div
            style={{
              paddingBottom: '0.5rem', // pb-2 = 8px = 0.5rem
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
            }}
          >
            <p
              className="welcome-text"
              style={{
                display: 'flex',
                flexDirection: 'row',
                fontSize: '1.125rem', // text-lg = 18px = 1.125rem
              }}
            >
              {('Sign')}{' '}
              <p
                style={{
                  color: '#7C0E6F',
                  paddingInlineStart: '0.5rem', // ps-2 = 0.5rem
                }}
              >
                {('Document')}
              </p>
            </p>
            <i
              className="las la-times-circle"
              style={{
                fontSize: '1.5rem', // text-2xl = 1.5rem = 24px
                cursor: 'pointer',
              }}
              onClick={() => closeModal(false)}
            ></i>
          </div>

          <div>
            <DigiSignatureTools
              attachment={viewData?.attachment}
              setAttachment={handleSubmit}
            />
          </div>
        </div>
      </Modal>
      <Modal open={openModel2} onClose={() => closeModal2(false)}>
        <div
          className="custom-modal3"
        >
          <ViewDigitalDocsController id={viewData?.id} onClose={() => closeModal2(false)} />
        </div>
      </Modal>
      <Modal open={openModel3} onClose={() => closeModal3(false)}>
        <ImageViewer
          url={attachment}
          onClose={() => closeModal3(false)}
          pdf={true}
        />
      </Modal>
    </Grid>
  );
};
export default DigitalSignaturePresenter;
